///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, OnInit } from '@angular/core';
import { ProjectWindowsPopupService } from '../project-windows-popup.service';
import { GtthHistoryService } from '../../logical-topology/engine/history-service';
import { GtthAutoConnectCommand } from '../../logical-topology/engine/commands/design/auto-connect-command';
import { AutoConnectType, GtthKeyValueDTO } from '../../../generated/shared-types.model';
import { ActiveRestorableWindow } from '../active-restorable-window';
import { GtthLogicalTopology } from '../../logical-topology/entities/logical-topology';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'winde-autoconnect-modal',
    templateUrl: './autoconnect-modal.component.html',
    standalone: false
})
export class GtthAutoconnectModalComponent extends ActiveRestorableWindow implements OnInit {
    autoconnectModes = AutoConnectType;
    autoConnectCommand: GtthAutoConnectCommand;
    public layers: GtthKeyValueDTO[];

    constructor(
        public dialogRef: MatDialogRef<GtthAutoconnectModalComponent>,
        public historyService: GtthHistoryService
    ) {
        super();
    }

    ngOnInit() {
        this.autoConnectCommand = this.historyService.command(GtthAutoConnectCommand).create();
        this.historyService.logicalTopology.autoConnectOptions.layerIndex = this.historyService.logicalTopology.activeLayerIdx;
        if (this.historyService.projectInfoViewService.isShowLayers) {
            this.layers = this.historyService.projectInfoViewService.layersOptions;
        }
    }

    numNodesChanged() {
        this.historyService.logicalTopology.autoConnectOptions.isNumNodesChanged = true;
    }

    closeModal() {
        this.dialogRef.close('cancel');
    }

    runAutoconnect() {
        this.closeModal();
        this.historyService.doCommand(this.autoConnectCommand);
    }

    designRequired(): boolean {
        return false;
    }

    isRestorable(): boolean {
        return true;
    }

    setRadiusForLayer(layerIndex) {
        if (layerIndex >= GtthLogicalTopology.DEFAULT_CONFIG_LAYER_INDEX) {
            this.historyService.logicalTopology.autoConnectOptions.radius =
                this.historyService.logicalTopology.productMaxDistancePerLayer[layerIndex];
        } else {
            this.historyService.logicalTopology.autoConnectOptions.radius = Math.max(
                ...this.historyService.logicalTopology.productMaxDistancePerLayer
            );
        }
    }
}

@Component({
    selector: 'winde-autoconnect-modal-popup',
    template: '',
    standalone: false
})
export class GtthAutoconnectPopupComponent implements OnInit {
    constructor(private readonly projectWindowsPopupService: ProjectWindowsPopupService) {}

    ngOnInit() {
        this.projectWindowsPopupService.openWindow(GtthAutoconnectModalComponent, 'sm');
    }
}
